export default "__VITE_ASSET__BLlyXjIV__"